import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter ml-4" }
const _hoisted_2 = { class: "agents-toolbar-center d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_AgentSummaryCard = _resolveComponent("AgentSummaryCard")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_SharedAgentCard = _resolveComponent("SharedAgentCard")!
  const _component_Agent = _resolveComponent("Agent")!
  const _component_ConfigCardOverlay = _resolveComponent("ConfigCardOverlay")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("p", null, "Agent configs. All fields are required. Agent prompt can be autofilled based on the name and description.", -1)
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.count > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.openCreateAgentOverlay,
                    size: "x-large",
                    tooltip: "New Agent",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn_toggle, {
                modelValue: _ctx.sortOrder,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortOrder) = $event)),
                mandatory: "",
                class: "ml-4",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-variant-remove",
                    value: "default",
                    size: "small",
                    title: "Default Order"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-ascending",
                    value: "asc",
                    size: "small",
                    title: "Sort Ascending"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-descending",
                    value: "desc",
                    size: "small",
                    title: "Sort Descending"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_combobox, {
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                    _ctx.filterAgentNames
                  ],
                  items: _ctx.configList,
                  "return-object": false,
                  "item-title": "name",
                  "item-value": "name",
                  clearable: "",
                  variant: "outlined",
                  density: "compact",
                  label: "Filter Agent",
                  "hide-details": ""
                }, {
                  append: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.count), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue", "items"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "outlined",
                  "prepend-icon": "mdi-video-plus-outline",
                  onClick: _ctx.openWorkflowVideoToAgent
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Video To Agent ")
                  ])),
                  _: 1,
                  __: [7]
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_v_tooltip, {
                text: "Refresh Agents",
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    color: "primary",
                    variant: "text",
                    icon: "",
                    loading: _ctx.refreshingAgents,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshAgentsView(true)))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-refresh")
                        ])),
                        _: 1,
                        __: [8]
                      })
                    ]),
                    _: 2
                  }, 1040, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.filteredAgentNames != null)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAgentNames, (agentName) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: agentName,
                  cols: _ctx.isDesktop ? 4 : 12,
                  class: "ma-0 pa-2",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AgentSummaryCard, {
                      agent: _ctx.agentConfigs[agentName],
                      variant: _ctx.isDesktop ? 'desktop' : 'compact',
                      onEdit: _ctx.openEditAgentOverlay
                    }, null, 8, ["agent", "variant", "onEdit"])
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128)),
              (_ctx.count === 0)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: _ctx.isDesktop ? 4 : 12,
                    class: "ma-0 pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        onClick: _ctx.openCreateAgentOverlay,
                        class: "ma-0 pa-2 card add-card",
                        color: "surface",
                        density: "compact",
                        variant: "elevated",
                        elevation: "4",
                        "min-height": "350"
                      }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("p", null, "New agent", -1)),
                          _createVNode(_component_v_icon, {
                            class: "add-icon",
                            icon: "mdi-plus"
                          })
                        ]),
                        _: 1,
                        __: [9]
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["cols"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.sharedAgentsSorted.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            density: "compact",
            class: "ma-0 pa-0 mt-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "ma-0 pa-2"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("h3", { class: "text-h6" }, "Shared Agents", -1),
                  _createElementVNode("p", { class: "text-body-2 text-medium-emphasis" }, "Agents shared with you.", -1)
                ])),
                _: 1,
                __: [10]
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedAgentsSorted, (sharedAgent) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: sharedAgent.agentId,
                  cols: _ctx.isDesktop ? 4 : 12,
                  class: "ma-0 pa-2",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SharedAgentCard, {
                      agent: sharedAgent,
                      onEdit: _ctx.openEditSharedAgentOverlay
                    }, null, 8, ["agent", "onEdit"])
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showCreateAgentOverlay,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCreateAgentOverlay) = $event)),
        title: "New Agent",
        onClose: _ctx.closeCreateAgentOverlay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Agent, {
            isOverlay: "",
            showTips: _ctx.showTips,
            onRemoveCard: _ctx.closeCreateAgentOverlay,
            onSaved: _ctx.handleAgentSaved
          }, null, 8, ["showTips", "onRemoveCard", "onSaved"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditAgentOverlay,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEditAgentOverlay) = $event)),
        title: "Edit Agent",
        onClose: _ctx.closeEditAgentOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingAgentId)
            ? (_openBlock(), _createBlock(_component_Agent, {
                key: 0,
                id: _ctx.editingAgentId,
                isOverlay: "",
                showTips: _ctx.showTips,
                startExpanded: true,
                onRemoveCard: _ctx.closeEditAgentOverlay,
                onSaved: _ctx.handleAgentSaved
              }, null, 8, ["id", "showTips", "onRemoveCard", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditSharedAgentOverlay,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showEditSharedAgentOverlay) = $event)),
        title: "Edit Shared Agent",
        onClose: _ctx.closeEditSharedAgentOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingSharedAgent)
            ? (_openBlock(), _createBlock(_component_Agent, {
                key: 0,
                sharedAgent: _ctx.editingSharedAgent,
                isOverlay: "",
                showTips: _ctx.showTips,
                startExpanded: true,
                onRemoveCard: _ctx.closeEditSharedAgentOverlay,
                onSaved: _ctx.handleSharedAgentSaved
              }, null, 8, ["sharedAgent", "showTips", "onRemoveCard", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ]),
    _: 1
  }))
}